import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const UserDeleteDialog = ({ open, onClose, onDelete, username }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-confirmation-dialog"
    >
      <DialogTitle id="delete-confirmation-dialog">Confirm Deactivation</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to deactivate <strong>{username}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={onDelete} color="error" variant="contained">
          Deactivate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDeleteDialog;
